module.exports = __webpack_public_path__ + "static/media/icon-note.b9e6d12f.svg";